import { z } from 'zod';

import { entityIdentifierSchema } from '../chat-entity';
import { blockModeSchema, questionnaireQuestionSchema } from './questionnaire-block';

export const diffValueTextSchema = z.object({
    type: z.literal('text'),
    value: z.string(),
});

export type DiffValueText = z.infer<typeof diffValueTextSchema>;

// TODO: legacy skill diff format, superseded by skill-changes — remove later.
export const diffValueEntitiesSchema = z.object({
    refs: z.array(entityIdentifierSchema),
    type: z.literal('entities'),
});

export type DiffValueEntities = z.infer<typeof diffValueEntitiesSchema>;

export const skillChangeKindSchema = z.enum(['added', 'removed', 'level_changed']);

export type SkillChangeKind = z.infer<typeof skillChangeKindSchema>;

export const skillChangeRowSchema = z.object({
    kind: skillChangeKindSchema,
    newLevel: z.number().nullish(),
    oldLevel: z.number().nullish(),
    skill: entityIdentifierSchema,
});

export type SkillChangeRow = z.infer<typeof skillChangeRowSchema>;

export const diffValueSkillChangesSchema = z.object({
    rows: z.array(skillChangeRowSchema),
    type: z.literal('skill-changes'),
});

export type DiffValueSkillChanges = z.infer<typeof diffValueSkillChangesSchema>;

export const diffValueSchema = z.discriminatedUnion('type', [
    diffValueTextSchema,
    diffValueEntitiesSchema,
    diffValueSkillChangesSchema,
]);

export type DiffValue = z.infer<typeof diffValueSchema>;

export const diffSchema = z.object({
    isMain: z.boolean().nullish(),
    newValue: diffValueSchema,
    oldValue: diffValueSchema,
    title: z.string(),
});

export type Diff = z.infer<typeof diffSchema>;

export const changeProposalBlockSchema = z.object({
    blockId: z.uuid(),
    callbackUrl: z.string().nullish(),
    diffs: z.array(diffSchema).min(1),
    mode: blockModeSchema,
    question: questionnaireQuestionSchema,
    title: z.string(),
    type: z.literal('change-proposal'),
});

export type ChangeProposalBlock = z.infer<typeof changeProposalBlockSchema>;
